var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24V21.4667L2 19.4667V24H0ZM5.5 24V16.1333L7.5 14.1333V24H5.5ZM11 24V14.1333L13 16.1667V24H11ZM16.5 24V16.1667L18.5 14.1667V24H16.5ZM22 24V10.8L24 8.8V24H22ZM0 16.1333V13.3L9.33333 4.03333L14.6667 9.36667L24 0V2.83333L14.6667 12.2L9.33333 6.86667L0 16.1333Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.b0ea0ea2f49a6f37c810a89a3fddde5d.svg";
export { ForwardRef as ReactComponent };